export default {
    path: '/hohohohoohohohoohho',
  };
  